export default __webpack_public_path__ + "static/media/kerala_study.0f6791d2.svg";